import { render, staticRenderFns } from "./newsPolicies.vue?vue&type=template&id=1d84e3b1&scoped=true&"
import script from "./newsPolicies.vue?vue&type=script&lang=js&"
export * from "./newsPolicies.vue?vue&type=script&lang=js&"
import style0 from "./newsPolicies.vue?vue&type=style&index=0&id=1d84e3b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d84e3b1",
  null
  
)

export default component.exports